import { API } from '@xbto/api-client';

export enum ChartTimeRange {
  H1 = '1H',
  H24 = '24H',
  W1 = '1W',
  M1 = '1M',
  M3 = '3M',
  Y1 = '1Y',
  Y3 = '3Y',
}

export enum ChartSeriesType {
  CandleStick = 'CandleStick',
  Area = 'Area',
}

export const ChartTimeRanges = [
  ChartTimeRange.H1,
  ChartTimeRange.H24,
  ChartTimeRange.W1,
  ChartTimeRange.M1,
  ChartTimeRange.M3,
  ChartTimeRange.Y1,
  ChartTimeRange.Y3,
];

export const FundChartTimeRanges = [ChartTimeRange.Y1, ChartTimeRange.Y3];

export enum AssetFundChartTimeRange {
  Y1 = '1Y',
  SINCE_INCEPTION = 'Since inception',
}

export const AssetFundChartTimeRanges = [
  AssetFundChartTimeRange.Y1,
  AssetFundChartTimeRange.SINCE_INCEPTION,
];

type _CommonChartData = {
  time: number;
  value: number;
};

export type TradingViewLineChartData = _CommonChartData & {
  formatted: { value: string };
};

export type AssetFundTradingViewLineChartData = _CommonChartData & {
  marker: API.GraphMarker | undefined;
  steps: number[] | undefined;
};

export type AssetFundTradingViewMarkerChartData = _CommonChartData;

export type TradingViewCandleStickChartData = {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  formatted: { value: string };
};

export type TradingViewChartData = {
  priceAxisTitle: string;
  currencyCode?: string;
  timeRange?: ChartTimeRange;
  seriesType?: ChartSeriesType;
  areaChartDataPoints: TradingViewLineChartData[] | null;
  candleStickChartDataPoints?: TradingViewCandleStickChartData[] | null;
  decimalPrecision?: number;
  errored: boolean;
  showOhlcvChart: boolean;
};

export type AssetFundTradingViewChartData = {
  asset: string;
  timeRange: AssetFundChartTimeRange;
  assetAmountDataPoints: AssetFundTradingViewLineChartData[] | null;
  usdValueDataPoints: AssetFundTradingViewLineChartData[] | null;
  assetAmountMarkersDataPoints: AssetFundTradingViewMarkerChartData[] | null;
  usdValueMarkersDataPoints: AssetFundTradingViewMarkerChartData[] | null;
  errored: boolean;
  loading: boolean;
};
